import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Camera, ArrowLeft } from 'lucide-react';
import { getToken } from '../lib/api';

// No habia ninguna. Una URL mal escrita, un enlace viejo de un correo o una
// pestana guardada de antes de un cambio de ruta daban una pagina en blanco, que
// para quien la ve no se distingue de una app rota. Y quien esta evaluando si
// compra no vuelve a intentarlo.
//
// Lleva a dos sitios distintos segun quien sea: quien ha iniciado sesion quiere
// volver a su trabajo, y quien no, a la portada.
export default function NotFound() {
  const { pathname } = useLocation();
  const signedIn = !!getToken();

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0E0E10] px-6 text-white">
      <div className="max-w-md text-center">
        <p className="font-serif-display text-6xl text-white/15">404</p>
        <h1 className="mt-4 font-serif-display text-2xl">There is nothing at this address</h1>
        <p className="mt-3 text-sm leading-relaxed text-white/50">
          The page{' '}
          <code className="rounded bg-white/5 px-1.5 py-0.5 text-white/70">{pathname}</code>{' '}
          does not exist. It may have been renamed, or the link that brought you
          here may have a typo in it.
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
          <Link
            to={signedIn ? '/app' : '/'}
            data-testid="notfound-home"
            className="inline-flex items-center gap-1.5 rounded-full bg-white px-5 py-2.5 text-sm font-medium text-black hover:bg-white/90"
          >
            {signedIn ? <Camera size={15} /> : <ArrowLeft size={15} />}
            {signedIn ? 'Back to your sessions' : 'Back to the home page'}
          </Link>
          {signedIn && (
            <Link
              to="/app/creations"
              className="rounded-full border border-[#2A2A30] px-5 py-2.5 text-sm text-white/70 hover:border-white/40 hover:text-white"
            >
              Your creations
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
